import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";
import { InvestmentType } from "types/InvestmentTypes";
import { TYPE_LABELS, formatDate, FileCell, DotsMenu } from "./tableUtils";

interface CryptoTableProps {
  transactions: InvestmentTransactionType[];
  item: InvestmentType | null;
  isOwn?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const CryptoTable = ({
  transactions,
  item,
  isOwn = false,
  onEditTx,
}: CryptoTableProps) => (
  <table className="itm-table">
    <thead>
      <tr>
        <th>Transakcja</th>
        <th>Ilość</th>
        <th>Data</th>
        <th>Kurs zakupu</th>
        {/* <th>Data pierwszego zakupu Tokenu/Kryptowaluty</th> */}
        <th>Umowa</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {transactions.map((tx) => (
        <tr key={tx.uuid}>
          <td>{TYPE_LABELS[tx.type] ?? tx.type}</td>
          <td>
            {tx.type === "buy" ? "+" : "-"}
            {tx.quantity ?? "—"}
          </td>
          <td>{formatDate(tx.completedAt ?? tx.createdAt)}</td>
          <td>{item?.primaryValue != null ? `${item.primaryValue}%` : "—"}</td>
          {/* <td>{formatDate(firstBuyDate)}</td> */}
          <td>
            <FileCell tx={tx} />
          </td>
          <td>
            <DotsMenu
              tx={tx}
              onEdit={
                isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
              }
            />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default CryptoTable;
